import { LOCALE } from '@hhgtech/hhg-components/types'

export const NATIVE_ADS_LOCALE: LOCALE[] = [LOCALE.India]
